<div class="lead-sources">
    <div class="lead-sources__header">
        <h3 class="lead-sources__title">{{ AppConstants.LEAD_SOURCES_TITLE }}</h3>
        <button
            class="lead-sources__info-icon"
            [eiTooltip]="getTooltipText()"
            eiTooltipPosition="top"
            aria-label="Info"
            type="button"
        >
            <img [src]="infoIcon" alt="" class="lead-sources__info-img" />
        </button>
    </div>

    @if (isLoading) {
        <div class="lead-sources__loading">
            <div class="lead-sources__spinner"></div>
        </div>
    } @else if (error) {
        <div class="lead-sources__error">
            <p class="lead-sources__error-text">{{ error }}</p>
        </div>
    } @else if (chartOptions) {
        <div class="lead-sources__chart">
            <apx-chart
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [labels]="chartOptions.labels"
                [colors]="chartOptions.colors"
                [legend]="chartOptions.legend"
                [dataLabels]="chartOptions.dataLabels"
                [tooltip]="chartOptions.tooltip"
                [responsive]="chartOptions.responsive"
                [plotOptions]="chartOptions.plotOptions"
            ></apx-chart>
        </div>
    }
</div>
